'use client'

import React, { FC } from 'react'
import classNamesBind from 'classnames/bind'
import css from './styles.module.scss'

const classNames = classNamesBind.bind(css)
import Image from 'next/image'

interface OwnProps {
  activeIndex: number
}

const getSignUpImages = () =>
  [
    {
      src: '/static/share/images/personality-predictions.png',
      text: 'Prepare for sales meetings',
    },
    {
      src: '/static/share/images/writing-assistant.png',
      text: 'Adapt emails for each recipient',
    },
    {
      src: '/static/share/images/playbook-meeting.png',
      text: 'Win over each stakeholder in a deal',
    },
  ].map((item, i) => (
    <div key={i + '-' + item.src} className={classNames('column-container')}>
      <div>
        <Image src={item.src} width={313} height={300} alt={'onboarding-carousel'} />
      </div>
      <div className={classNames('sub-header')}>{item.text}</div>
    </div>
  ))

const ImageCarousel: FC<OwnProps> = ({ activeIndex }: OwnProps) => {
  return (
    <div className={classNames('mask')}>
      <div className={classNames('row', 'index' + activeIndex)}>
        {getSignUpImages()?.map(item => item)}
      </div>
    </div>
  )
}

export default ImageCarousel
